const hasDisplayValue = (value) =>
  value !== null && value !== undefined && value !== ''

const getValue = (object, ...keys) => {
  if (!object) {
    return undefined
  }

  return keys.reduce((value, key) => {
    if (value !== undefined && value !== null) {
      return value
    }

    return object[key]
  }, undefined)
}

export const normalizeSurfaceReconciliation = (reconciliation) => {
  if (!reconciliation || typeof reconciliation !== 'object') {
    return null
  }

  const sowingStatus = getValue(
    reconciliation,
    'sowingStatus',
    'sowing_status'
  )
  const declaredSownSurfaceHa = getValue(
    reconciliation,
    'declaredSownSurfaceHa',
    'declared_sown_surface_ha'
  )
  const harvestStatus = getValue(
    reconciliation,
    'harvestStatus',
    'harvest_status'
  )
  const declaredHarvestedSurfaceHa = getValue(
    reconciliation,
    'declaredHarvestedSurfaceHa',
    'declared_harvested_surface_ha'
  )
  const yieldMapCoverageStatus = getValue(
    reconciliation,
    'yieldMapCoverageStatus',
    'yield_map_coverage_status'
  )
  const consistencyStatus = getValue(
    reconciliation,
    'consistencyStatus',
    'consistency_status'
  )
  const rawConsistencyIssues = getValue(
    reconciliation,
    'consistencyIssues',
    'consistency_issues',
    'issues'
  )
  const consistencyIssues = Array.isArray(rawConsistencyIssues)
    ? rawConsistencyIssues
    : rawConsistencyIssues
    ? [rawConsistencyIssues]
    : []
  const hasReconciliation = [
    sowingStatus,
    declaredSownSurfaceHa,
    harvestStatus,
    declaredHarvestedSurfaceHa,
    yieldMapCoverageStatus,
    consistencyStatus,
  ].some(hasDisplayValue)

  if (!hasReconciliation) {
    return null
  }

  return {
    ...reconciliation,
    sowingStatus,
    declaredSownSurfaceHa,
    harvestStatus,
    declaredHarvestedSurfaceHa,
    yieldMapCoverageStatus,
    consistencyStatus,
    consistencyIssues,
  }
}

export const mergeSurfaceReconciliationForDisplay = (
  declaration,
  calculation
) => {
  if (!declaration) {
    return null
  }

  return {
    ...(calculation || {}),
    ...declaration,
    consistencyStatus:
      calculation?.consistencyStatus ?? declaration.consistencyStatus,
    consistencyIssues:
      calculation?.consistencyIssues?.length > 0
        ? calculation.consistencyIssues
        : declaration.consistencyIssues || [],
  }
}

export const getSurfaceReconciliationConsistencyIssues = (
  declaration,
  calculation
) => {
  const reconciliation = mergeSurfaceReconciliationForDisplay(
    declaration,
    calculation
  )

  if (reconciliation?.consistencyStatus !== 'inconsistent') {
    return []
  }

  return reconciliation.consistencyIssues?.length
    ? reconciliation.consistencyIssues
    : ['unknown']
}

const normalizeWarning = (warning) =>
  String(warning || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

const isHarvestedSurfaceExceedsSownWarning = (warning) => {
  const normalizedWarning = normalizeWarning(warning)

  return (
    normalizedWarning.includes('superficie cosechada declarada') &&
    normalizedWarning.includes('superficie sembrada resuelta')
  ) || (
    normalizedWarning.includes('declared harvested surface') &&
    normalizedWarning.includes('resolved sown surface')
  )
}

export const filterDuplicateSurfaceReconciliationWarnings = (
  warnings,
  hasSpecializedConsistencyWarning
) => {
  if (!Array.isArray(warnings) || !hasSpecializedConsistencyWarning) {
    return warnings
  }

  return warnings.filter(
    (warning) => !isHarvestedSurfaceExceedsSownWarning(warning)
  )
}
